interface VersionLike {
  readonly id: string;
}

export function projectVersionLifecycleKey(version: VersionLike): string {
  return version.id;
}
